import { BrowserModule } from '@angular/platform-browser';
import { NgModule, NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';
import { NgxSpinnerModule } from 'ngx-spinner';
import { NgxPaginationModule } from 'ngx-pagination';
import { NgOtpInputModule } from 'ng-otp-input';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FeesStructureComponent } from './staticpages/fees-structure/fees-structure.component';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { BnNgIdleService } from 'bn-ng-idle';

@NgModule({ declarations: [
        AppComponent,
    ],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA,
        NO_ERRORS_SCHEMA
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        BrowserAnimationsModule,
        FormsModule,
        AppRoutingModule,
        NgxSpinnerModule,
        NgxSpinnerModule,
        NgxPaginationModule,
        NgOtpInputModule,
        CarouselModule,
        BsDatepickerModule.forRoot(),
        ToastrModule.forRoot({
            timeOut: 10000,
            toastClass: 'ngx-toastr',
            extendedTimeOut: 1000
        })], providers: [BnNgIdleService, provideHttpClient(withInterceptorsFromDi())] })
export class AppModule { }
